// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

// Other configuration constants can be added here
export default {
  API_BASE_URL
};
